import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PendoTable from '../../components/table/pendo-table.vue.js';
import PendoButton from '../../components/button/pendo-button.vue.js';
import moment from 'moment';

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
var script = {
  name: 'RevokedKeys',
  components: {
    PendoButton,
    PendoTable
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    loadingState: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      defaultSort: {
        prop: 'revokedAt',
        order: 'descending'
      },
      columns: [{
        prop: 'id',
        label: 'Signing Key Name',
        sortable: true
      }, {
        prop: 'description',
        label: 'Description',
        width: '250px',
        sortable: true
      }, {
        prop: 'secret',
        label: 'Key',
        width: '500px',
        sortable: false
      }, {
        label: 'Revoked Time',
        prop: 'revokedAt',
        sortable: true,
        formatter: row => moment(row.revokedAt).format('MMM D, YYYY h:mm:ss A z')
      }, {
        label: 'Revoked By',
        prop: 'revokedByUser.username',
        sortable: true
      }, {
        type: 'actions',
        width: '80px'
      }]
    };
  },
  mounted: _async(function () {
    const _this = this;
    return _await(_this.$nextTick(), function () {
      _this.$refs.revokedtable.collapseTable();
    });
  }),
  methods: {
    handleToggleSecret(row) {
      this.$refs.revokedtable.updateRow(_objectSpread2(_objectSpread2({}, row), {}, {
        showSecret: !row.showSecret
      }));
    }
  }
};

export { script as default };
//# sourceMappingURL=revoked-keys.vue2.js.map
